import { ReactNode, useRef } from "react";
import { Outlet } from "react-router";
import SimpleBarCore from "simplebar-core";

import { SidebarListProps } from "./SidebarList";
import { ExpandingSidebarList } from "./ExpandingSidebarList";

import { EXPANDING_SIDEBAR_WIDTH } from "@/layouts/constants";
import { SidebarLayout } from "@/layouts/secondary-sidebar-layout";

interface ExpandingSidebarContentProps {
  variant: "content";
  children: ReactNode;
}

export interface ExpandingSidebarListProps extends SidebarListProps {
  variant: "list";
  showSearch?: boolean;
}

type ExpandingSidebarProps = ExpandingSidebarContentProps | ExpandingSidebarListProps;

export function ExpandingSidebar(props: ExpandingSidebarProps) {
  const { variant } = props;
  const simpleBarRef = useRef<SimpleBarCore | null>(null);

  const hasSidebarContent = variant === "content" || props.sidebarItems.length > 0;

  return (
    <SidebarLayout
      showSidebar={hasSidebarContent}
      sidebarRef={simpleBarRef}
      sidebarWidth={EXPANDING_SIDEBAR_WIDTH}
      sidebarContent={
        hasSidebarContent && <>{variant === "content" ? props.children : <ExpandingSidebarList {...props} />}</>
      }
      hideable
    >
      <Outlet />
    </SidebarLayout>
  );
}
